import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { createPatient } from './api';

/**
 * Lives in features/patients rather than features/registration because
 * patient creation is not exclusive to the Visit Workflow Register stage —
 * Patient Records is expected to gain its own quick-add path eventually, and
 * both should share this one mutation rather than each wrapping the route
 * separately.
 */
export function useCreatePatient() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPatient,
    onSuccess: () => {
      // Invalidate rather than patch in place: the patient roster and search
      // results are queried with arbitrary filters (q=, today-activity), so
      // there is no single cache entry to append the new row into safely.
      queryClient.invalidateQueries({ queryKey: keys.patients.all() });
    },
  });
}
